// ESTILOS
import styles from '../../estilos/inicioRegistro.module.css';
// PAQUETES
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";

 
function Alerta() {
  const location = useLocation(); 

  // Declaramos navigate para redirección
  const navigate = useNavigate();
  const { returnTo, returnState } = location.state || {}; // páginas a las que se debe volver en dado caso, como reserva o otroas.
  const { usuario, cargandoUsuario, setUsuario } = useOutletContext() || {}; // variables de context


  return(
    <div className={styles.containerAlerta} >
      <h1 className="my-5">¡Alerta!</h1>
      <h3 className='' >{location.state?.titulo}</h3>
      <p className='mb-5 mt-2 mx-3' style={{textAlign: 'justify'}}  >{location.state?.mensaje}</p>
      <button
        type="button"
        className="btn btn-primary"
        onClick={() => {
          const url = location.state?.urlMensaje || "/";
          return navigate(url, {
            state: {
              returnTo,
              returnState,
            },
          });
        }}
      >
        {location.state?.nombreBoton}
      </button>
    </div>
  )
}


export default Alerta;